import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { round, debounce } from 'lodash';
import RelatedCareersCard from './RelatedCareersCard';
import chevron from '../../../ASUPhotos/icons/carouselChevron.svg';

export class CustomCarousel extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.carouselRow = React.createRef();
    this.state = {
      index: 1,
      scrollWidth: 1,
      scrollLeft: 0,
    };
  }

  CARD_WIDTH = 235;

  CARD_MARGIN = 12;

  totalIncrement = () => {
    return this.CARD_MARGIN + this.CARD_WIDTH;
  };

  displayRelatedCareersCard = () => {
    return this.props.careers.map((career) => {
      return (
        <RelatedCareersCard
          careerId={career.id}
          career={career}
          key={career.id}
          title={career.titleEn}
          photoUrl={career.categoryImageVariant}
          careerOutlook={career.careerOutlook}
          cardWidth={this.CARD_WIDTH}
          cardMargin={this.CARD_MARGIN}
          setBrightOutlookModal={this.props.setBrightOutlookModal}
        />
      );
    });
  };

  updateScrollWidth = () => {
    return (
      this.carouselRow.current &&
      this.setState({
        scrollWidth:
          this.carouselRow.current.scrollWidth -
          this.carouselRow.current.offsetWidth,
      })
    );
  };

  componentDidMount = () => {
    window.addEventListener('resize', this.debounceUpdateScrollWidth);
  };

  debounceUpdateScrollWidth = debounce(this.updateScrollWidth, 500);

  debounceUpdateScrollPosition = debounce(
    () => this.updateScrollPosition(),
    250
  );

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.debounceUpdateScrollWidth);
  };

  scrollCarousel = (num) => {
    const { index } = this.state;
    const newIndex = index + num;
    const currentPos = this.carouselRow.current.scrollLeft;
    const rounded = round(currentPos / this.totalIncrement());
    const leftScroll =
      this.totalIncrement() * rounded + this.totalIncrement() * num;
    this.carouselRow.current.scrollTo({
      top: 0,
      left: leftScroll,
      behavior: 'smooth',
    });
    this.setState({
      index: newIndex,
    });
  };

  updateScrollPosition = () => {
    this.setState({
      scrollLeft: this.carouselRow.current.scrollLeft,
    });
    this.updateScrollWidth();
  };

  disablePrev = () => {
    if (!this.carouselRow || !this.carouselRow.current) return false;
    return this.carouselRow.current.leftScroll <= 0;
  };

  render() {
    const { scrollLeft, scrollWidth } = this.state;
    return (
      <div id="custom-carousel" className="custom-carousel">
        <div
          className={classNames({
            'custom-carousel__carousel-row': true,
            [this.props.carouselClassName]: this.props.carouselClassName,
          })}
          ref={this.carouselRow}
          onScroll={this.debounceUpdateScrollPosition}
        >
          {this.displayRelatedCareersCard(this.props.careers)}
          {/* The custom carousel has a fade at the end.
            We need to add hidden boxes in order to leave room 
            to view the last career outside of the fade.  */}
          <RelatedCareersCard careerId={false} />
          <RelatedCareersCard careerId={false} />
        </div>
        <div
          className={classNames({
            'custom-carousel__carousel-buttons': true,
            [this.props.carouselClassName]: this.props.carouselClassName,
          })}
        >
          <div
            role="button"
            tabIndex={0}
            style={{ visibility: scrollLeft <= 0 ? 'hidden' : 'visible' }}
            onClick={() => {
              this.scrollCarousel(-1);
            }}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) this.scrollCarousel(-1);
            }}
            className="custom-carousel__chevron"
          >
            <img
              src={chevron}
              alt="Previous slide"
              className="custom-carousel__rotate-180"
            />
          </div>
          <div
            role="button"
            tabIndex={0}
            style={{
              visibility: scrollLeft >= scrollWidth ? 'hidden' : 'visible',
            }}
            onClick={() => {
              this.scrollCarousel(1);
            }}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) this.scrollCarousel(1);
            }}
            className="custom-carousel__chevron"
          >
            <img src={chevron} alt="Next slide" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = state.tenant;
  return { tenant };
};

export default connect(mapStateToProps)(CustomCarousel);
